import React, { useEffect, useRef } from "react";

/// Holds the page-top banners and publishes their height as
/// `--banner-offset`, so the global toast — `position: fixed` at the viewport
/// top, mounted above this layout — lands below them instead of over them.
/// Measured rather than counted, because a banner can wrap to two lines.
export const BannerSlot: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const root = document.documentElement;
    const publish = () =>
      root.style.setProperty("--banner-offset", `${el.offsetHeight}px`);
    publish();
    const observer = new ResizeObserver(publish);
    observer.observe(el);
    return () => {
      observer.disconnect();
      root.style.removeProperty("--banner-offset");
    };
  }, []);

  return <div ref={ref}>{children}</div>;
};
